class HHAnnouncementBar extends HTMLElement {
  constructor() {
    super()

    this.autoRotate = parseInt(this.dataset.autoRotate) || 0
    this.slider = this.querySelector('.js-announcement-bar-slider')
    this._doSlider = this._doSlider.bind(this)
  }

  connectedCallback() {
    this._doSlider()
  }

  _doSlider() {
    const config = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false
    }

    if (this.autoRotate) {
      config.autoplay = true
      config.autoplaySpeed = this.autoRotate
    }
    $(this.slider).slick(config)
  }
}

customElements.define('hh-announcement-bar', HHAnnouncementBar)
